export default "__VITE_ASSET__BJR5HN_J__"